import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TLocationCoordinates, TOperationIssueAndMarkedLocations } from '@monorepo/types';
import { InputAppAPIHelperUtil } from '@monorepo/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-mark-location',
  templateUrl: './mark-location.component.html',
  styleUrls: ['./mark-location.component.scss'],
})
export class MarkLocationComponent implements OnInit {
  @Input() isImageCapturingEnabled = false;
  @Input() operationIssueAndMarkedLocationsList: TOperationIssueAndMarkedLocations[] = [];
  @Input() silhouette_front = '';
  @Input() silhouette_back = '';
  @Input() shillohutteId: string = '';
  @Input() showDepartmentName?: boolean = false;
  @Output() back = new EventEmitter<TOperationIssueAndMarkedLocations[]>();
  @Output() cancel = new EventEmitter<'CANCEL'>();
  @Output() done = new EventEmitter<TOperationIssueAndMarkedLocations[]>();
  @Output() clearAll = new EventEmitter<'CLEAR_ALL'>();
  @Output() addPhoto = new EventEmitter<'ADD_PHOTO'>();

  backArrow = '/assets/md-point/header-back-arrow.svg';
  undoIcon = '/assets/common/undo-icon.svg';
  defaultSilhoutte = '/assets/common/default-silhoutte.svg';
  activeIndex: number = 0;
  dotColors: string[] = [];
  frontLocations: TLocationCoordinates[] = [];
  backLocations: TLocationCoordinates[] = [];
  locatioMarkingStack: { marktype: 'FRONT' | 'BACK'; index: number }[] = [];

  constructor(private inputAppAPIHelperUtil: InputAppAPIHelperUtil, private translate: TranslateService) {}

  ngOnInit(): void {
    console.log('[operationIssueAndMarkedLocationsList]', this.operationIssueAndMarkedLocationsList);
    this.#assignUniqueColorToOperationIssueMarkedLocations();
    if (this.shillohutteId === 'DEFAULT') {
      this.silhouette_front = this.defaultSilhoutte;
      this.silhouette_back = this.defaultSilhoutte;
    }
  }

  #assignUniqueColorToOperationIssueMarkedLocations() {
    const updatedDotColor: string[] = [];
    this.operationIssueAndMarkedLocationsList = this.operationIssueAndMarkedLocationsList.map((item) => {
      const color = '#' + Math.random().toString(16).slice(-6);
      updatedDotColor.push(color);
      return {
        ...item,
        front_locations: item.front_locations.map((location) =>
          this.#addColorKeyFromLocationCoordinate(location, color),
        ),
        back_locations: item.back_locations.map((location) => this.#addColorKeyFromLocationCoordinate(location, color)),
      };
    });
    this.operationIssueAndMarkedLocationsList.forEach((item) => {
      this.frontLocations = this.frontLocations.concat(item.front_locations);
      this.backLocations = this.backLocations.concat(item.back_locations);
      console.log('[ITEM]', item);
      console.log('[FrontLocations --> loop]', this.frontLocations);
      console.log('[BackLocation --> loop]', this.backLocations);
    });
    this.dotColors = updatedDotColor;
    console.log('[FrontLocations]', this.frontLocations);
    console.log('[BackLocation]', this.backLocations);
    console.log('[operationIssueAndMarkedLocationsList]', this.operationIssueAndMarkedLocationsList);
    console.log('[UPDATE_DOT_COLOR]', updatedDotColor);
  }

  #addColorKeyFromLocationCoordinate(location: TLocationCoordinates, color: string) {
    const updatedLocation: TLocationCoordinates = {
      ...location,
      color: color,
    };
    return updatedLocation;
  }

  #removeColorKeyFromLocationCoordinate(location: TLocationCoordinates) {
    delete location.color;
    return location;
  }

  updateActiveIndex(index: number) {
    this.activeIndex = index;
  }

  takePhoto() {
    this.addPhoto.emit('ADD_PHOTO');
  }

  handleBack() {
    this.back.emit(
      this.operationIssueAndMarkedLocationsList.map((item) => {
        return {
          ...item,
          front_locations: item.front_locations.map((location) => this.#removeColorKeyFromLocationCoordinate(location)),
          back_locations: item.back_locations.map((location) => this.#removeColorKeyFromLocationCoordinate(location)),
        };
      }),
    );
  }

  handleLocationMarkingOnFront(location: TLocationCoordinates) {
    console.log('[MARK LOCATION] Front', location);
    this.frontLocations.push(location);
    this.locatioMarkingStack.push({ marktype: 'FRONT', index: this.activeIndex });
    this.operationIssueAndMarkedLocationsList[this.activeIndex] = {
      ...this.operationIssueAndMarkedLocationsList[this.activeIndex],
      front_locations: [...this.operationIssueAndMarkedLocationsList[this.activeIndex].front_locations, location],
    };
  }

  handleLocationMarkingOnBack(location: TLocationCoordinates) {
    console.log('[MARK LOCATION] Back', location);
    this.backLocations.push(location);
    this.locatioMarkingStack.push({ marktype: 'BACK', index: this.activeIndex });
    this.operationIssueAndMarkedLocationsList[this.activeIndex] = {
      ...this.operationIssueAndMarkedLocationsList[this.activeIndex],
      back_locations: [...this.operationIssueAndMarkedLocationsList[this.activeIndex].back_locations, location],
    };
  }

  handleMarkingUndo() {
    const locatioMarkingStackItem = this.locatioMarkingStack.pop();
    if (locatioMarkingStackItem) {
      if (locatioMarkingStackItem.marktype === 'FRONT') {
        this.operationIssueAndMarkedLocationsList[locatioMarkingStackItem.index].front_locations.pop();
        this.frontLocations.pop();
      } else {
        this.operationIssueAndMarkedLocationsList[locatioMarkingStackItem.index].back_locations.pop();
        this.backLocations.pop();
      }
    } else
      this.inputAppAPIHelperUtil.showPopup(
        this.translate.instant('mark_location.error'),
        this.translate.instant('mark_location.errorMessage'),
      );
  }

  handleDone() {
    const isDoneCondition = this.operationIssueAndMarkedLocationsList.find(
      (item) => item.back_locations.length > 0 || item.front_locations.length > 0,
    );
    if (isDoneCondition) {
      console.log(
        '[FINAL_DEFECTIVE_OPERATION_ISSUE_AND_SILHOUTTE_LOCATIONS]',
        this.operationIssueAndMarkedLocationsList,
      );
      this.done.emit(this.operationIssueAndMarkedLocationsList);
    } else
      this.inputAppAPIHelperUtil.showPopup(
        this.translate.instant('input_app_common.alert'),
        this.translate.instant('mark_location.alertMessage'),
      );
  }

  handleClearAll() {
    this.frontLocations = [];
    this.backLocations = [];
    this.locatioMarkingStack = [];
    this.operationIssueAndMarkedLocationsList = this.operationIssueAndMarkedLocationsList.map((item) => {
      return {
        ...item,
        front_locations: [],
        back_locations: [],
      };
    });
    this.clearAll.emit('CLEAR_ALL');
  }

  handleCancel() {
    this.cancel.emit('CANCEL');
  }
}
